<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
    <h2 *ngIf="edit"> Edit {{contextualHelp.functionality}} Contextual Help</h2>
      <h2 *ngIf="!edit">Create Contextual Help</h2>
      <div class="close" (click)="bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  #ngForm="ngForm" id="contextualHelpForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="input-fields">
                <div>
                  <label for="">Description</label>
                  <textarea name="contextualHelpDescription" [(ngModel)]="contextualHelp.descriptionText" style="min-height: 150px;">

                  </textarea>
                </div>
                <div>
                  <label for="userManualLink">
                      Link
                  </label>
                  <input name="userManualLink" type="text" [(ngModel)]="contextualHelp.link">
                </div>
                <div>
                  <label for="userManualLinkName">
                      Link Name
                  </label>
                  <input name="userManualLinkName" type="text" [(ngModel)]="contextualHelp.linkName">
                </div>
                <div>
                  <label for="contextualHelpEnabledCheckbox">
                    Enabled
                  </label>
                  <input type="checkbox" name="contextualHelpEnabledCheckbox" (click)="selectEnabled()" [checked]="contextualHelp.isEnabled"
                  [disabled]="contextualHelp.functionality == 'Contextual Help'">
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit"(click)="save()" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button class="gray" (click)="bsModalRef.hide()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
